var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',[_c('div',{staticClass:"header__logo"},[_c('router-link',{attrs:{"to":_vm.route}},[_c('img',{staticStyle:{"height":"80px","margin-top":"5px"},attrs:{"src":_vm.logo,"alt":""}})])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29cbb9ec","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/PmNavLogo.vue
// module id = 100
// module chunks = 0